import { Icon } from '@cbhq/cds-web/icons/Icon';
import { VStack } from '@cbhq/cds-web/layout';
import { TextBody } from '@cbhq/cds-web/typography';
import { memo } from 'react';
import { useAccount } from 'wagmi';
import { Box } from '@cbhq/cds-web/layout';
import { AccountConnectButton } from '@/onchain/components';

export const PortfolioPositionsEmptyState = memo(function PortfolioPositionsEmptyState() {
  const account = useAccount();

  return (
    <VStack
      testID="portfolio-positions-empty-state"
      paddingY={4}
      gap={3}
      alignItems="center"
      justifyContent="center"
    >
      <Icon name="smartContract" size="l" />
      <VStack paddingX={2}>
        <TextBody as="p" textAlign="center" numberOfLines={2} color="fgMuted">
          Your active liquidity positions will appear here.
        </TextBody>

        {account.address === undefined && (
          <TextBody as="p" textAlign="center" numberOfLines={2} color="fgMuted">
            Connect to a wallet with a Coinbase Verification to add liquidity.
          </TextBody>
        )}
      </VStack>
      {account.address === undefined && (
        <Box maxWidth="240px" width="100%">
          <AccountConnectButton />
        </Box>
      )}
    </VStack>
  );
});
